import React from 'react';
import Modal from '../../Components/Modal';
import { useAddQuote } from '../../Data/Quotes';
import QuoteForm from '../Quote/QuoteForm';

const AddQuote = ({isOpen, setIsOpen, onAdded}) => {
    const {addQuote} = useAddQuote();

    return <Modal title="Add quote" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        <QuoteForm quote={{}} onSubmit={addQuote} afterSubmit={onAdded} />
    </Modal>
}

export default AddQuote;
